import React from 'react'
import {connect} from 'react-redux'
import qs from 'query-string'

import tracker from '../../common/tracker'

import * as actions from '../actions'
import ResetPassPage from './ResetPassPage'
import RequestResetPage from './RequestResetPage'

class ResetPassSwitch extends React.Component {
  componentDidMount() {
    let url_query = qs.parse(this.props.location.search)

    //a:resetActivated, where 1 is true
    if(url_query.a === '1'){
      // the reason we are doing is this is because there is only one /reset
      // URL and its component uses the resetActivated flag to determine which
      // page the user actually sees (i.e., request or submit)
      this.props.setResetActivated(true)
    }
    else{
      tracker.resetLoaded()
    }
    if (url_query.msg)
      this.props.setPasswordResetStatus({status: url_query.status, msg: 'testing'})

  }

  render() {
    if (this.props.resetActivated)
      return <ResetPassPage {...this.props} />

    return <RequestResetPage {...this.props} />
  }
}

const mapStateToProps = (state) => ({
  resetActivated: state.auth.resetActivated
})

const ResetPassSwitchWrapper = connect(mapStateToProps, actions)(ResetPassSwitch)

export {ResetPassSwitchWrapper as default, ResetPassSwitch}



// WEBPACK FOOTER //
// ./assets/auth/components/ResetPassSwitch.js